import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import Link, { LinkPresentationProps, LinkProps } from "@insite/mobius/Link";
import React, { FC } from "react";

const GenrateUrl: FC<{ link: LinkFieldValue; style?: LinkPresentationProps | LinkProps | undefined, openInNewTab?: boolean }> = props => {
    const url = useGetLink(props.link);
    const style = props.style;
  
    if (!style) {
        return <Link href={url.url}>{props.children}</Link>;
    }
    return (
        <Link href={url.url} target={props.openInNewTab ? "_blank" : ""} {...props.style}>
            {props.children}
        </Link>
    );
};

export default GenrateUrl;
